import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { imageAsset } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  backgroundColor,
  title,
  description[]{${richTextFields}},
  ${imageAsset.fragment('leftImage')},
  ${imageAsset.fragment('centerImage')},
  ${imageAsset.fragment('rightImage')}
`

export const fragment = (name = 'aboutHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
